// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2znzX","modal":"Modal_modal__2QgxK","slide-down":"Modal_slide-down__Y0TjC"};